import { useCallback, useContext } from 'react';
import createDataContext from '../services/createDataContext';

import submissionsReducer, {
	SET_DOCUMENT,
	SET_EVAL_ERROR,
	SET_EVALUATION
} from '../reducers/submissionsReducer';
import { getEvaluation } from '../api/nora/eval';

export let controller = new AbortController();

const initialState = {
	document: null,
	evalError: null,
	evaluation: null
};

const onInit = () => {
	controller = new AbortController();
};

const onCleanup = () => {
	controller.abort();
};

export const {
	StateContext,
	ActionContext,
	Provider
} = createDataContext( {
	reducer: submissionsReducer,
	initialState,
	controller,
	onInit,
	onCleanup
} );

export function useSubmissionState() {
	const state = useContext( StateContext );

	return state;
}

export function useSubmissionAction() {
	const dispatch = useContext( ActionContext );

	const setDocument = useCallback( async document => {
		SET_DOCUMENT( dispatch, controller.signal )( document );

		try {
			if ( document?.eval.evalID ) {
				const evaluation = await getEvaluation( document.id );

				SET_EVALUATION( dispatch, controller.signal )( evaluation );
			} else {
				SET_EVALUATION( dispatch, controller.signal )( null );
			}
		} catch ( error ) {
			SET_EVAL_ERROR( dispatch, controller.signal )( error );
		}
	}, [ dispatch ] );

	return { setDocument };
}
